var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05313 0C9.65 0 10.0812 0.571875 9.91562 1.14375L8.24375 7H10.9062C11.5094 7 11.9969 7.4875 11.9969 8.09062C11.9969 8.4125 11.8562 8.71562 11.6125 8.92188L3.52812 15.7875C3.36562 15.925 3.15938 16 2.94688 16C2.35 16 1.91875 15.4281 2.08437 14.8562L3.75625 9H1.05625C0.471875 9 0 8.52812 0 7.94688C0 7.6375 0.134375 7.34687 0.36875 7.14687L8.47188 0.215625C8.63438 0.075 8.84063 0 9.05313 0ZM7.925 2.65625L2.2625 7.5H4.75C4.98438 7.5 5.20625 7.60938 5.35 7.79688C5.49375 7.98438 5.5375 8.22812 5.47188 8.45312L4.07188 13.3594L9.79688 8.5H7.25C7.01562 8.5 6.79375 8.39062 6.65 8.20312C6.50625 8.01562 6.4625 7.77187 6.52812 7.54688L7.925 2.65625Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltIconImage);
export default __webpack_public_path__ + "static/media/boltIconImage.d653f276abe1c627eefc4172211c614e.svg";
export { ForwardRef as ReactComponent };